import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
import { V } from '../../common/Layout';
import { useStyling } from '../../common/Theme';
import { Field } from '../attributes';
import TypePreview from '../TypePreview';

type TextAttributePreviewProps = {
    field: Field;
    onClick?: (field) => void;
};

export default (props: TextAttributePreviewProps) => {
    const { field, onClick } = props;
    const { theme } = useStyling();

    return (
        <V onClick={onClick}>
            <TypePreview type={field.fieldType} />
            <EllipsisText text={field.label} sx={{ width: '140px' }} />
            <EllipsisText
                text={field.description}
                clampLines={2}
                sx={{ fontSize: 'smaller', color: theme.palette.text.disabled }}
            />
        </V>
    );
};
